var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 196.264 196.264",
    style: {
      enableBackground: "new 0 0 196.264 196.264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M191.277,93.136L173.182,0H27.953L4.984,93.315v2.645v28.438v5.132v28.434v4.731v33.57h186.297 v-33.57v-4.731v-28.434v-5.132V95.96v-2.824H191.277z M31.653,4.724h137.628l16.813,86.501H10.366L31.653,4.724z M186.546,191.54 H9.715v-28.846h176.831V191.54z M186.546,157.963H9.715v-28.434h176.831V157.963z M186.546,124.397H9.715V95.96h176.831V124.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M163.398,117.419c4.638,0,8.407-3.769,8.407-8.407c0-4.638-3.769-8.41-8.407-8.41 c-4.638,0-8.41,3.772-8.41,8.41C154.988,113.65,158.76,117.419,163.398,117.419z M163.398,105.329 c2.026,0,3.679,1.657,3.679,3.683c0,2.026-1.653,3.679-3.679,3.679c-2.026,0-3.683-1.653-3.683-3.679 C159.715,106.986,161.372,105.329,163.398,105.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M163.398,151.818c4.638,0,8.407-3.772,8.407-8.41c0-4.638-3.769-8.414-8.407-8.414 c-4.638,0-8.41,3.776-8.41,8.414C154.988,148.046,158.76,151.818,163.398,151.818z M163.398,139.729 c2.026,0,3.679,1.646,3.679,3.679c0,2.026-1.653,3.683-3.679,3.683c-2.026,0-3.683-1.657-3.683-3.683 C159.715,141.375,161.372,139.729,163.398,139.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M163.398,184.343c4.638,0,8.407-3.772,8.407-8.41s-3.769-8.407-8.407-8.407 c-4.638,0-8.41,3.769-8.41,8.407S158.76,184.343,163.398,184.343z M163.398,172.254c2.026,0,3.679,1.653,3.679,3.679 s-1.653,3.683-3.679,3.683c-2.026,0-3.683-1.657-3.683-3.683S161.372,172.254,163.398,172.254z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.903,
    y: 102.964,
    style: {
      fill: "#010002"
    },
    width: 43.73,
    height: 6.048
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.903,
    y: 134.343,
    style: {
      fill: "#010002"
    },
    width: 43.73,
    height: 6.048
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.903,
    y: 166.871,
    style: {
      fill: "#010002"
    },
    width: 43.73,
    height: 6.045
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.fe5eef97e1c71ffe661bc4ac01da2240.svg";
export { ForwardRef as ReactComponent };